module.exports = (require("./helpers/browser/import-polyfill")(parcelRequire.resolve("lDyMq"))).then(() => parcelRequire('hYhFp'));